import { func, number, oneOfType, string } from 'prop-types';
import React, { useCallback, useContext, useState } from 'react';
import getSymbolFromCurrency from 'currency-symbol-map';
import AppContext from './context/AppContext';

// Constants
const DEFAULT_QTY = 1;

export default function ProductChildProduct({ childProductId, childProductName, childProductPrice, childProductQty, maxQty, addToCart, inventoryLevelId, isAddedToCart }) {
    const { appContext } = useContext(AppContext);
    const appConfig = appContext.config.themeConfig;

    // Set the current quantity to the child product quantity
    const [currentQty, setCurrentQty] = useState(String(DEFAULT_QTY));

    // Update the current quantity when the user changes the quantity
    const handleCurrentQtyChange = useCallback((e) => setCurrentQty(
        parseInt(e.target.value || DEFAULT_QTY, 10)
    ), []);

    // Add or remove a product from the cart
    const handleCheckboxChange = useCallback(() =>
        addToCart(inventoryLevelId, currentQty), [currentQty, addToCart, inventoryLevelId]);
    
    return (
        <tr>
            <td>{childProductId}</td>
            <td>{childProductName}</td>
            <td>
                <strong>
                    {getSymbolFromCurrency(appConfig.storeCurrency)}{childProductPrice} {appConfig.storeCurrency}
                </strong>
            </td>
            <td>
                <input
                    type={'number'}
                    value={currentQty}
                    min={DEFAULT_QTY}
                    max={maxQty}
                    onChange={handleCurrentQtyChange} />
            </td>
            <td>
                <input
                    disabled={!inventoryLevelId}
                    type={'checkbox'}
                    onChange={handleCheckboxChange}
                    checked={isAddedToCart} />
            </td>
        </tr>
    );
}

ProductChildProduct.propTypes = {
    childProductId: string.isRequired,
    childProductName: string.isRequired,
    childProductPrice: oneOfType([string, number]),
    childProductQty: oneOfType([string, number]),
    maxQty: oneOfType([string, number]),
    inventoryLevelId: oneOfType([string, number]),
    addToCart: func,
    isAddedToCart: string,
};